var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconStrokeStande20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.8901L11.3268 6.20905C11.5881 5.93032 12.0119 5.93032 12.2732 6.20905L17.6 11.8901M7.33846 10.4626V16.8863C7.33846 17.2804 7.63809 17.6 8.00769 17.6H10.4615V14.5071C10.4615 14.1129 10.7612 13.7934 11.1308 13.7934H12.4692C12.8388 13.7934 13.1385 14.1129 13.1385 14.5071V17.6H15.5923C15.9619 17.6 16.2615 17.2804 16.2615 16.8863V10.4626M9.56923 17.6H14.4769",
    stroke: "#343634",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconStrokeStande20);
export default __webpack_public_path__ + "static/media/Home-Icon-Stroke-Stande2.0.a8d83ce554258b9470aee01265da067b.svg";
export { ForwardRef as ReactComponent };